import React, { useContext, useState } from 'react';
import 'antd/dist/antd.css';
import { Button, Select } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';

import { displayMessage } from '../../services/helper';

export default function MonitorFilters(props) {

    const [currentFilters, setCurrentFilters] = useState({})

    const {mobile_mode} = useContext(GeneralContext)


    const handleOnFilterChange = (type, value, parameterName) => {
        let currentFiltersUpdated = currentFilters

        if (type == 'date') {
            currentFiltersUpdated[parameterName] = value ? value.format('DD/MM/YYYY') : null
        }

        if (type == 'option') {
            currentFiltersUpdated[parameterName] = value
        }

        if (type == 'autocomplete') {
            currentFiltersUpdated[parameterName] = value
        }
        
        setCurrentFilters({ ...currentFiltersUpdated })
    }

    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    marginBottom: 15,
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>

                <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                        </div>
                    </div>

                    <div  style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 5, alignItems: 'flex-end', marginTop: 10, padding: 5 }}>
                        <Button
                            onClick={() => props.handleOnSearchMonitors(currentFilters)}
                            type="primary"
                            style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                        >
                            {displayMessage('SEARCH')}
                        </Button>
                    </div>
                </div>
            </div>
        </div >


    )
}


